document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.mobile-menu-button');
  const menu = document.getElementById('MobileMenu');

  if (button && menu) {
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      menu.classList.toggle('is-open', !open);
    });
  }
});


document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('[data-predictive-search]');
  if (!wrapper) return;
  const input = wrapper.querySelector('input[type="search"]');
  const results = wrapper.querySelector('.predictive-search');
  let controller; let timer;
  const money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: 'EUR' });
  const esc = value => String(value ?? '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const normalize = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[’']/g,' ').replace(/[^a-z0-9а-яёіїєґ]+/gi,' ').trim();
  function mappedQuery(query) {
    const syn = window.NM_SEARCH_SYNONYMS || {};
    const raw = normalize(query);
    const tokens = raw.split(/\s+/).map(token => syn[token] || token);
    return tokens.join(' ');
  }
  function translatedTitle(product) {
    const locale=(document.documentElement.lang || 'fr').split('-')[0];
    const handle=(product.url || '').split('/products/')[1]?.split(/[?#]/)[0] || product.handle || '';
    return window.NM_PRODUCT_TITLES?.[locale]?.[handle] || product.title;
  }
  function closeResults(){results.hidden=true;results.innerHTML='';input.setAttribute('aria-expanded','false');}
  async function fetchSuggest(q,signal){
    const root=window.Shopify?.routes?.root || '/';
    const url=`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku,tag`;
    const response=await fetch(url,{signal}); if(!response.ok) throw new Error('search');
    const data=await response.json(); return data.resources?.results?.products || [];
  }
  async function searchProducts(query){
    if(controller) controller.abort(); controller=new AbortController();
    const mapped=mappedQuery(query); const requests=[fetchSuggest(query,controller.signal)];
    if(mapped && mapped!==normalize(query)) requests.push(fetchSuggest(mapped,controller.signal));
    try{
      const groups=await Promise.all(requests); const seen=new Set(); const products=[];
      groups.flat().forEach(p=>{if(!seen.has(p.url)){seen.add(p.url);products.push(p);}});
      if(!products.length){results.innerHTML=`<div class="predictive-empty">${esc(input.dataset.noResults || 'Aucun résultat')}</div>`;}
      else{
        results.innerHTML=products.slice(0,10).map(product=>`<a class="predictive-product" href="${esc(product.url)}"><span class="predictive-product__image">${product.image?`<img src="${esc(product.image)}" alt="">`:''}</span><span class="predictive-product__text"><strong>${esc(translatedTitle(product))}</strong><small>${esc(product.vendor||'')}</small></span><span class="predictive-product__price">${money.format(Number(product.price||0))}</span></a>`).join('')+`<a class="predictive-view-all" href="/search?q=${encodeURIComponent(mapped || query)}&type=product">${document.documentElement.lang.startsWith('ru')?'Все результаты':document.documentElement.lang.startsWith('uk')?'Усі результати':'Voir tous les résultats'}</a>`;
      }
      results.hidden=false; input.setAttribute('aria-expanded','true');
    }catch(error){if(error.name!=='AbortError') closeResults();}
  }
  input.addEventListener('input',()=>{clearTimeout(timer);const q=input.value.trim();if(q.length<2){closeResults();return;}timer=setTimeout(()=>searchProducts(q),140);});
  input.addEventListener('focus',()=>{if(results.innerHTML) results.hidden=false;});
  document.addEventListener('click',e=>{if(!wrapper.contains(e.target)) closeResults();});
  input.addEventListener('keydown',e=>{if(e.key==='Escape') closeResults();});
  wrapper.querySelector('form')?.addEventListener('submit',e=>{const mapped=mappedQuery(input.value);if(mapped && mapped!==normalize(input.value)){input.value=mapped;}});
});

document.addEventListener('DOMContentLoaded', () => {
  const megaMenu = document.querySelector('[data-mega-menu]');
  if (!megaMenu) return;

  document.addEventListener('click', event => {
    if (!megaMenu.contains(event.target)) megaMenu.removeAttribute('open');
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      megaMenu.removeAttribute('open');
      megaMenu.querySelector('summary')?.focus();
    }
  });

  megaMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => megaMenu.removeAttribute('open'));
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const mainImage = gallery.querySelector('#ProductMainImage');
    const thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');
    if (!mainImage || !thumbnails.length) return;

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        mainImage.src = thumbnail.dataset.gallerySrc;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumbnail.dataset.galleryAlt || '';
        thumbnails.forEach(item => item.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-quantity-selector]').forEach(selector => {
    const input = selector.querySelector('input');
    const minus = selector.querySelector('[data-quantity-minus]');
    const plus = selector.querySelector('[data-quantity-plus]');
    if (!input) return;

    minus?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    });

    plus?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  const zoomButton = document.querySelector('[data-product-zoom]');
  const zoomDialog = document.querySelector('[data-product-zoom-dialog]');
  const zoomClose = document.querySelector('[data-product-zoom-close]');
  const mainImage = document.getElementById('ProductMainImage');

  if (zoomButton && zoomDialog && mainImage) {
    zoomButton.addEventListener('click', () => {
      const image = zoomDialog.querySelector('img');
      image.src = mainImage.currentSrc || mainImage.src;
      image.alt = mainImage.alt;
      if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
    });
    zoomClose?.addEventListener('click', () => zoomDialog.close());
    zoomDialog.addEventListener('click', event => {
      if (event.target === zoomDialog) zoomDialog.close();
    });
  }

  document.querySelectorAll('[data-product-recommendations]').forEach(section => {
    if (section.innerHTML.trim()) return;
    const url = section.dataset.url;
    if (!url) return;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const replacement = html.querySelector('[data-product-recommendations]');
        if (replacement && replacement.innerHTML.trim()) {
          section.innerHTML = replacement.innerHTML;
        }
      })
      .catch(() => {});
  });
});


document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-predictive-search]').forEach((wrapper,index)=>{if(index===0)return;const input=wrapper.querySelector('input[type=search]'),results=wrapper.querySelector('.predictive-search');if(!input||!results)return;let timer,controller;const norm=v=>String(v||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9а-яёіїєґ]+/gi,' ').trim();const map=q=>norm(q).split(/\s+/).map(t=>(window.NM_SEARCH_SYNONYMS||{})[t]||t).join(' ');input.addEventListener('input',()=>{clearTimeout(timer);const q=input.value.trim();if(q.length<2){results.hidden=true;return}timer=setTimeout(async()=>{if(controller)controller.abort();controller=new AbortController();try{const root=window.Shopify?.routes?.root||'/';const mq=map(q);const resp=await fetch(`${root}search/suggest.json?q=${encodeURIComponent(mq||q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`,{signal:controller.signal});const data=await resp.json();const ps=data.resources?.results?.products||[];results.innerHTML=ps.length?ps.map(p=>`<a class="predictive-product" href="${p.url}"><span class="predictive-product__image">${p.image?`<img src="${p.image}" alt="">`:''}</span><span class="predictive-product__text"><strong>${p.title}</strong><small>${p.vendor||''}</small></span><span class="predictive-product__price">${Number(p.price||0).toLocaleString('fr-FR',{style:'currency',currency:'EUR'})}</span></a>`).join(''):`<div class="predictive-empty">Aucun résultat</div>`;results.hidden=false}catch(e){}} ,120)})})});
document.addEventListener('DOMContentLoaded',()=>{const toast=document.createElement('div');toast.className='nm-cart-toast';toast.setAttribute('role','status');document.body.appendChild(toast);const say=t=>{toast.textContent=t;toast.classList.add('is-visible');clearTimeout(window.__nmt);window.__nmt=setTimeout(()=>toast.classList.remove('is-visible'),1500)};document.addEventListener('submit',async e=>{const form=e.target.closest('.quick-add-form');if(!form)return;e.preventDefault();const btn=form.querySelector('button');if(btn?.classList.contains('is-loading'))return;btn?.classList.add('is-loading');try{const rr=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});if(!rr.ok)throw 0;const card=form.closest('.product-card'),img=card?.querySelector('.product-card__image img'),cart=document.querySelector('.cart-link');if(img&&cart){const a=img.getBoundingClientRect(),b=cart.getBoundingClientRect(),c=img.cloneNode(true);c.className='nm-fly-image';Object.assign(c.style,{left:a.left+'px',top:a.top+'px',width:Math.min(a.width,100)+'px',height:Math.min(a.height,100)+'px'});document.body.appendChild(c);requestAnimationFrame(()=>requestAnimationFrame(()=>Object.assign(c.style,{left:(b.left+b.width/2-18)+'px',top:(b.top+b.height/2-18)+'px',width:'36px',height:'36px',opacity:'.15',transform:'scale(.35) rotate(8deg)'})));setTimeout(()=>c.remove(),680)}const cr=await fetch((window.Shopify?.routes?.root||'/')+'cart.js');const cj=await cr.json();document.querySelectorAll('.cart-count').forEach(x=>x.textContent=cj.item_count);btn?.classList.remove('is-loading');const l=(document.documentElement.lang||'fr').slice(0,2);say(l==='ru'?'Добавлено в корзину':l==='uk'?'Додано до кошика':'Ajouté au panier')}catch(err){btn?.classList.remove('is-loading');form.submit()}})});
